import React, { useState, useEffect } from "react";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Button from 'react-bootstrap/Button';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useProductContext } from "../Context/ProductContext";

const ProductIngredients = (props) => {
  const { ingredient, handleProductRegenerate, previewMode, loading, initialSku, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [previousResponse, setPreviousResponse] = useState("");
  const { updateProductData } = useProductContext();

  const convertIngredientToString = (ingredientData) => {
    if (!ingredientData) return "";
    if (typeof ingredientData === "string") return ingredientData;
    if (Array.isArray(ingredientData)) {
      return ingredientData.map(item =>
        typeof item === "string" ? item : JSON.stringify(item)
      ).join("\n");
    }
    return Object.entries(ingredientData)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");
  };

  const [ingredients, setIngredients] = useState(convertIngredientToString(ingredient));

  useEffect(() => {
    const ingredientString = convertIngredientToString(ingredient);
    setIngredients(ingredientString);
    if (ingredientString && ingredientString.trim() !== "") {
      setPreviousResponse(ingredientString);
    }
  }, [ingredient]);

  const toggleEdit = () => {
    if (isEditing) {
      // Save the updated ingredients when exiting edit mode
      const updatedData = {
        ingredients: ingredients
      };
      updateProductData(initialSku, "ingredients", updatedData);
    }
    setIsEditing(!isEditing);
  };

  const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("ingredients", ingredients);
  };

  const handleRegenerate = async (type, formData, ingredients) => {
    let furtherDetailsToSend = "";
    let customPromptToSend = null;

    if (typeof formData === "object" && formData !== null) {
      if (formData.reason?.trim()) {
        furtherDetailsToSend = formData.reason;
      }
    } else if (typeof formData === "string") {
      furtherDetailsToSend = formData;
    }

    await handleProductRegenerate(type, furtherDetailsToSend, ingredients, customPromptToSend, previousResponse);
  };

  const getDisplayText = () => {
    const text = convertIngredientToString(ingredient);
    return text || ingredients;
  };


  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">Product ingredients</div>
        {!previewMode && (
          isEditing ? (
            <Button variant="dark" onClick={handleDoneClick}>Done</Button>
          ) : (
            <div className="button-group">
              <BaseButton
                className="outlineprimary"
                children="Regenerate Text"
                imageSrc="/regenerate-text.svg"
                isModalOpen={true}
                handleClick={(formData) => handleRegenerate("ingredients", formData, ingredients)}
              />
              {isHidden && onUnhide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Unhide Section"
                  handleClick={onUnhide}
                />
              ) : onHide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Hide Section"
                  handleClick={() => onHide(sectionId, sectionTitle)}
                />
              ) : null}
              <BaseButton
                className="outlineprimary btn-sm"
                children="Edit Text"
                imageSrc="/edit-text.svg"
                handleClick={toggleEdit}
              />
            </div>
          )
        )}
      </div>

      <div className="">
        {loading ? (
          <div>
            <Skeleton height={12} width="90%" style={{ marginBottom: 5 }} count={5} />
          </div>
        ) : isEditing ? (
          <textarea
            value={ingredients}
            onChange={(e) => setIngredients(e.target.value)}
            className="product-description-input form-control"
          />
        ) : (
          <div className="description-tabs">
            <ul className="mb-0">
              {getDisplayText()
                .split("\n")
                .filter((line) => line.trim() !== "")
                .map((line, index) => (
                  <li className="productDescription" key={index}>{line}</li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductIngredients;

